import React, { FunctionComponent ,useState,useEffect,useContext} from "react";
import {useLocation} from 'react-router-dom';
import SocialCardList from "./SocialCardList";
import SocialCardListSkeleton from "./SocialCardListSkeleton";
import { ErrorContent503,NotFoundContent,NotFoundContentTimeline,NotFoundContentHome } from "../layout";
import {FiltersContext,MapSocialParams,applyOriginalsOnly} from "../../service/filters";
import {apiProvider,ApiParamsType} from "../../service/data/apiProvider";
import {roundCurrentTime,getDayEnd} from "../../service/tools/Tools";

import classNames from "classnames";
import Masonry from "react-masonry-component";
import AdvancedSearchForm from "../layout/AdvancedSearchForm";
import {Box, Typography} from "@material-ui/core";
import {useTranslate} from "../../service/translation/hooks";
import {useTopicStyles} from "../topic";
import {useContentStyles} from "../layout/useContentStyles";


interface SocialItemsListProps {
    providerId?: number,
    resultsType?: string
}

const SocialItemsList: FunctionComponent<SocialItemsListProps> = (props: SocialItemsListProps) => {
    const classes = useContentStyles();
    const translate = useTranslate();
    const {providerId,resultsType} = props;
    const [filters,setFilters] = useContext(FiltersContext);
    const [itemsState, setItemsState] = useState<any>(null);
    const [isFetching, setIsFetching] = useState(0); //0  not fetching 1-by params, 2-next page
    // Counts refresh requests. isFetching alone could not carry them: it stays 1 until half a second
    // after a response lands, so setIsFetching(1) during a fetch changed nothing, the fetch effect
    // never ran, and a filter ticked in that window was silently dropped. Opening the Filters panel
    // starts such a fetch, so ticking right after opening it hit this every time on a slow network.
    const [refreshRequests, setRefreshRequests] = useState(0);
    const refresh = () => {
        setIsFetching(1);
        setRefreshRequests(n => n + 1);
    };
	const [nextPage, setNextPage] = useState('');
    const [hasError,setHasError] = useState(false);
    const [version,setVersion] = useState(0);
    const [total, setTotal] = useState(0);

    let intervalId:any = React.useRef(null);
    let lastVersion = React.useRef(0);

    // The home feed asks the API for originals and quotes only; the check for new content must
    // ask the same, or a reply nobody will see would light the "new posts" banner.
    const scopeParams = (params:ApiParamsType):ApiParamsType =>
        (resultsType === 'home')? applyOriginalsOnly(params) : params;
    
    useEffect(() => {
        if(intervalId.current) clearInterval(intervalId.current);
        //setFilters({...appDefaultFilters});
        window.removeEventListener('scroll', handleScroll);
        window.addEventListener('scroll', handleScroll);
	}, []);

    React.useEffect(() => {
        
        if(lastVersion.current >= version) return;
        lastVersion.current = version;
        //check new content
        if( !itemsState || itemsState.length === 0) return;
        let newFilters = {...filters};
        newFilters.form.to = getDayEnd();
        let params = {...newFilters};
        params.form.pageNo = 0;

        apiProvider.getSocialItems( scopeParams({...MapSocialParams(params)}),providerId)
        .then(response => {
        
            if (itemsState.length > 0
                && response.items.length > 0
                && itemsState[0].id !== response.items[0].id)
                {
                    newFilters.newContent = 1;
                    setFilters(newFilters);
                    if(intervalId.current) clearInterval(intervalId.current);
                }
        });
    },[version]);


    React.useEffect(() => {
        if(filters.newContent !== 2) return;
        refresh();

    },[filters.newContent])


    const setNewcontentInterval = () => {
        if(intervalId.current) clearInterval(intervalId.current);
        let i = 0;
        intervalId.current =  setInterval(() => {setVersion(i++)}, 60000)
    };


    const handleScroll = () => {
        if (
            (document.documentElement.scrollTop + window.innerHeight < document.body.scrollHeight - 800)
     		||	isFetching > 0
		){
		    return;
        }
        setIsFetching(2);
	};


     const fetchData = (toNextPage:boolean = false) => {
        console.log('Filters Effect form');
        let params:ApiParamsType| string;

        let newFilters = {...filters};

        console.log('Form >>> ', newFilters.form);
        if(toNextPage){
            if(!nextPage || nextPage === '') return;
            params = nextPage;

        }else {
            newFilters.form.to = roundCurrentTime(1);
            if(resultsType === 'timeline' && newFilters.timeline.from === 0){
                newFilters.timeline.to = newFilters.form.to;
                newFilters.timeline.from = newFilters.form.to - 3600 * 24;
            }

            params = scopeParams({...MapSocialParams(newFilters)});
        }
        console.log('PARAMS',params );
        if(hasError) setHasError(false);
        apiProvider.getSocialItems(params, providerId)
        .then((response) => {
            let oldItems = (itemsState === null)? [] :itemsState;
            let newState = (toNextPage)? [...oldItems, ...response.items] : [...response.items];
            
            setNextPage(response.next);
            setTotal(response.total);
            setItemsState(newState);
            setTimeout(() => {setIsFetching(0);}, 500);
            setNewcontentInterval();

            console.log('counter results in tsocialItems list',response.total );
            if(!toNextPage) {
                // Only what this response knows, onto the filters as they are now. Spreading the
                // copy taken when the request was sent undid any filter changed while it was in
                // flight: a box ticked meanwhile stayed ticked on screen, but not in the state, so
                // nothing refetched.
                setFilters((current:any) => ({
                    ...current,
                    topicsVersion: current.topicsVersion + 1,
                    counterResults : response.total
                }));
            }

        })
        .catch((error) => {
            console.log('ERROR >>', error);
            setHasError(true);
        });
	};



    useEffect(() => {
        refresh();
    },[providerId,filters.activeTopics,filters.form,filters.advancedSearch.filters]);


    useEffect(() => {
        if (isFetching === 0) return 
        let toNextPage = (isFetching === 2)? true: false;
        // A newer request supersedes one still in flight: apiProvider drops the older response.
        fetchData(toNextPage);
	}, [isFetching, refreshRequests]);

    useEffect(() => {
        if (filters.newContent) return;
        refresh();
	}, [filters.newContent]);


    if ( itemsState === null || isFetching === 1) {
        return (
          <SocialCardListSkeleton numItems={5} />
         );
    }

    if(hasError){
        return (
            <ErrorContent503/>
        );
    }

    if(itemsState.length === 0){
        switch (resultsType){
            case 'home':
                return (
                    <NotFoundContentHome/>
                );
                break;
            case 'timeline':
                return (
                    <NotFoundContentTimeline/>
                );
                break;
            
            default:
                return (
                    <NotFoundContent/>
                );
        }
    }

    
    return (
        <>
        { !/tw|embed/.test(window.location.pathname)  && 
            <Box mb={1} className={classes.counterContainer}>
                <Typography variant={"h6"} component={"p"}>{translate((total ===1)?  "newshub.pagination.resultsOne": "newshub.pagination.results",{total:total})}</Typography>
            </Box>
        }
            <SocialCardList
                showCounter
                data={itemsState}
                page={1}
                pageSize={25}
                stackConsecutive={!providerId}
                total={itemsState.length}
            />
        </>
    );
};

export default SocialItemsList;
